<template>
  <div class="payment">
    <mu-container>
      <van-form
        @submit="payment_submit"
      >
        <van-cell-group title="基本信息" :border="true" size="large">
          <van-field
            v-model="paymentForm.no"
            label="申请编号"
            size="large"
            :border="true"
            readonly
          />
          <van-field
            v-model="paymentForm.title"
            label="标题"
            size="large"
            required
            :border="true"
            placeholder="请输入标题"
          />
          <van-field
            v-model="paymentForm.budget_year"
            label="预算月份"
            size="large"
            :border="true"
            required
            readonly
            is-link
            @click="budget_years.show = true"
            placeholder="请选择预算月份"
            :rules="[{ required: true, message: '请选择月份' }]"
          />
          
          <van-action-sheet
            v-model="budget_years.show"
            :actions="budget_years.data"
            @select="budget_year_onselect"
          />
          <van-field
            v-model="paymentForm.cost_center"
            label="预算成本中心"
            size="large"
            :border="true"
            placeholder="请选择成本中心"
            required
            @click="cost_center.show = true"
            readonly
            is-link
            :rules="[{ required: true, message: '请选择成本中心' }]"
          />
          <van-action-sheet
            v-model="cost_center.show"
            :actions="cost_centers"
            @select="cost_center_onselect"
          />
          <van-field
            v-model="paymentForm.target_income"
            label="预计收款"
            size="large"
            required
            type="number"
            :border="true"
            placeholder="机构才需要填写，其他成本中心请填0"
          />
          <van-field
            v-model="paymentForm.desc"
            label="预算说明"
            rows="5"
            type="textarea"
            size="large"
            :border="true"
            placeholder="请输入预算说明"
          />
          <!-- <van-field v-model="paymentForm.ps" label="附言"   size='large' :border="true" placeholder="请输入附言内容,附言内容不打印" /> -->
          <!-- <van-field v-model="paymentForm.contract_no" label="合同编号" size='large' :border="true" placeholder="请输入合同编号" />
          <van-field v-model="paymentForm.contract_url" label="合同链接" size='large' :border="true" placeholder="请输入合同链接" /> -->
        </van-cell-group>
        <van-cell-group title="申请人信息" :border="true">
          <van-field
            v-model="paymentForm.user_name"
            label="姓名"
            required
            size="large"
            :border="true"
            readonly
          />
          <van-field
            v-model="paymentForm.department"
            label="部门"
            required
            size="large"
            placeholder="请选择所在部门"
            @click="department.show = true"
            :rules="[{ required: true, message: '请选择所在部门' }]"
            readonly
            is-link
          />
          <van-action-sheet
            v-model="department.show"
            :actions="department.options"
            @select="department_onselect"
          />
          <van-field
            v-model="paymentForm.position"
            label="职位"
            required
            size="large"
            :border="true"
            readonly
          />
          <!-- <van-field v-model="paymentForm.is_self" readonly center label="是否本人报销" size='large' :border="true" is-link @click="is_self.show = true"  :rules="[{ required: true, message: '请选择是否本人报销' }]"/>
          <van-action-sheet v-model="is_self.show" :actions="is_self.options" @select="is_self_onselect" /> -->
        </van-cell-group>
        <van-cell-group title="预算明细" :border="true">
          <van-field
            v-for="item in paymentForm.costs"
            :key="item.account_id"
            v-model="item.amount"
            :label="item.cost_account"
            type="number"
            size="large"
            :border="true"
            placeholder="请输入预算金额，如无，请留空。"
          />
        </van-cell-group>
        <van-cell-group title="总计" :border="true">
          <van-field
            v-model="amount"
            label="预算总金额"
            size="large"
            readonly
            :border="true"
          />
          <van-field
            v-model="paymentForm.amount_word"
            label="金额大写"
            size="large"
            readonly
            :border="true"
          />
        </van-cell-group>
        <van-cell-group title="附件上传" :border="true">
          <div
            class="img_box"
            v-for="(file, index) in files"
            :v-if="file"
            :key="index"
          >
            <div class="upload_img" v-if="type(file) == 'image'">
              <van-image
                width="5rem"
                height="5rem"
                fit="contain"
                :src="file"
                @click="getImg(index)"
              >
                <van-icon
                  name="close"
                  @click="deleteFile(index)"
                  class="delete"
                />
              </van-image>
            </div>
            <div class="upload_img" v-else-if="type(file) == 'pdf'">
              <a :href="file"
                ><van-image
                  width="4rem"
                  height="4rem"
                  fit="contain"
                  src="/images/filesicon/pdf.png"
                >
                  <van-icon
                    name="close"
                    @click="deleteFile(index)"
                    class="delete"
                  /> </van-image
              ></a>
            </div>
            <div class="upload_img" v-else-if="type(file) == 'excel'">
              <a :href="file"
                ><van-image
                  width="4rem"
                  height="4rem"
                  fit="contain"
                  src="/images/filesicon/xls.png"
                >
                  <van-icon
                    name="close"
                    @click="deleteFile(index)"
                    class="delete"
                  /> </van-image
              ></a>
            </div>
            <div class="upload_img" v-else-if="type(file) == 'word'">
              <a :href="file"
                ><van-image
                  width="4rem"
                  height="4rem"
                  fit="contain"
                  src="/images/filesicon/docx.png"
                >
                  <van-icon
                    name="close"
                    @click="deleteFile(index)"
                    class="delete"
                  /> </van-image
              ></a>
            </div>
            <div class="upload_img" v-else-if="type(file) == 'zip'">
              <a :href="file"
                ><van-image
                  width="4rem"
                  height="4rem"
                  fit="contain"
                  src="/images/filesicon/zip.png"
              /></a>
              <van-icon
                name="close"
                @click="deleteFile(index)"
                class="delete"
              />
            </div>
            <div class="upload_img" v-else-if="type(file) == 'rar'">
              <a :href="file"
                ><van-image
                  width="4rem"
                  height="4rem"
                  fit="contain"
                  src="/images/filesicon/rar.png"
                >
                  <van-icon
                    name="close"
                    @click="deleteFile(index)"
                    class="delete"
                  /> </van-image
              ></a>
            </div>
          </div>
        </van-cell-group>
        <van-cell-group>
          <!-- <van-uploader style="margin:20px auto;" :after-read="uploadFile"> -->
          <van-uploader
            style="margin: 20px auto"
            multiple
            :after-read="uploadFiles"
          >
            <van-button icon="plus" type="primary" native-type="button"
              >附件上传（支持批量）</van-button
            >
          </van-uploader>
        </van-cell-group>

        <Approver :approvers="paymentForm.approvers"></Approver>
        <CopyTo :copytos="paymentForm.copytos"></CopyTo>

        <div style="margin: 20px 0 50px 0">
          <van-row>
            <!-- <van-col span="12"><van-button type="primary" native-type="submit">保存草稿</van-button></van-col> -->
            <van-col span="24"
              ><van-button
                :loading="is_loading"
                loading-text="提交中..."
                type="info"
                native-type="submit"
                >提交审批</van-button
              ></van-col
            >
          </van-row>
        </div>
      </van-form>
    </mu-container>
  </div>
</template>

<script>
import Header from "../../components/Header.vue";
import Approver from "../../components/Payment/Approver.vue";
import CopyTo from "../../components/Payment/CopyTo.vue";
import AddBudgetCost from "../../components/Payment/AddBudgetCost.vue";
import PayInfo from "../../components/Payment/PayInfo.vue";
import { digit_uppercase } from "../../assets/js/digitUppercase.js";
import { ImagePreview } from "vant";
import { fileType } from "../../assets/js/fileType.js";

export default {
  components: { Header, Approver, AddBudgetCost, PayInfo, CopyTo },
  name: "Administrative",
  props: {},
  data() {
    return {
      cost_centers: {},
      cost_center: {
        show: false,
        cost_center: "",
        center_id: "",
      },
      budget_years: {
        show: false,
        data: [{ name: "202201" }],
      },
      cost_account: {},
      user: {},
      is_repeat: 0,
      is_loading: false,
      department: {
        show: false,
        options: {},
      },
      flow_id: this.$route.query.from_flow_id,
      costs: [
        {
          cost_account: "",
          account_id: "",
          amount: "",
        },
      ],
      paymentForm: {
        no: "",
        catalog_id: 20,
        cost_center: "",
        center_id: "",
        target_income:0,
        userid: "",
        title: "",
        desc: "",
        ps: "",
        budget_year: "",
        user_name: "",
        department: "",
        department_id:'',
        position: "",
        amount: "",
        amount_word: "",
        costs: [
          {
            cost_account: "",
            account_id: "",
            amount: "",
          },
        ],
        approvers: [],
        copytos: [],
        filelist: [],
      },
      files: [],
      approverForm:{
        department_id:'',
      }
    };
  },
  created() {
    document.title = "预算申请（机构）";
    // this.getCostCenter()
    // this.getCostAccount()
    // this.getUserInfo();
    this.getBaseInfo();
    this.getApprover();
    this.getBudgetAccount();
  },
  methods: {
    getFlow() {
      this.$http.get("/flow/" + this.flow_id).then((res) => {
        console.log(res);
        this.paymentForm.title = res.data.data.title;
        this.paymentForm.desc = res.data.data.desc;
        this.paymentForm.ps = res.data.data.ps;
        this.paymentForm.budget_year = res.data.data.budget_year;
        this.paymentForm.center_id = res.data.data.center_id;
        this.payInfos.payer = res.data.data.payer;
        this.payInfos.payer_id = res.data.data.payer_id;
        this.paymentForm.payer_id = res.data.data.payer_id;
        this.payInfos.payee = res.data.data.payee;
        this.payInfos.bank = res.data.data.bank;
        this.payInfos.bank_account = res.data.data.bank_account;
        this.payInfos.payment_term = res.data.data.payment_term;
        this.paymentForm.filelist = res.data.data.filelist;
        // this.paymentForm.department_id = res.data.data.department_id;
        // this.approverForm.department_id = res.data.data.department_id;
        this.files = res.data.data.files;
        this.costs = res.data.data.costs;
        this.getApprover();
      });
    },
    getBaseInfo() {
      this.$http.post("flow/base_info", this.paymentForm).then((res) => {
        console.log(res);
        if (res.data.code == 204) {
          this.$router.push({ name: "Login" });
          return false;
        }
        if (res.data.code != 200) {
          console.log(res.data.msg);
        }
        this.cost_centers = res.data.data.cost_centers;
        this.cost_accounts = res.data.data.cost_accounts;
        this.user = res.data.data.user_info;
        this.paymentForm.no = res.data.data.flow_no;
        this.paymentForm.position = this.user.position;
        this.paymentForm.user_name = this.user.name;
        this.paymentForm.userid = this.user.userid;
        this.department.options = this.user.departments;
        // this.payInfos.payee = res.data.data.user_account.name;
        // this.payInfos.bank = res.data.data.user_account.bank;
        // this.payInfos.bank_account = res.data.data.user_account.bank_account;
        this.paymentForm.title = this.user.name + "提交的预算申请";
        if (this.user.departments.length == 1) {
          this.paymentForm.department = this.user.departments[0].name;
          this.paymentForm.department_id = this.user.departments[0].Id;
          this.approverForm.department_id = this.user.departments[0].Id
          // this.getApprover();
        }
        if (this.flow_id) {
          this.getFlow();
        }
      });
    },
    getBudgetAccount() {
      this.$http.get("budget_account").then((res) => {
        this.paymentForm.costs = res.data.data;
      });
    },
    getUserInfo() {
      this.$http.post("user_info", { userid: this.userid }).then((res) => {
        console.log(res.data.code);
        if (res.data.code != 200) {
          console.log(res.data.msg);
        }
        this.user = res.data.data;
        this.paymentForm.position = this.user.position;
        this.paymentForm.user_name = this.user.name;
        this.paymentForm.userid = this.user.userid;
        this.department.options = this.user.departments;
      });
    },
    cost_center_onselect(item) {
      console.log(this.paymentForm);
      this.cost_center.show = false;
      this.paymentForm.cost_center = item.name;
      this.paymentForm.center_id = item.id;
      this.getApprover();
    },
    budget_year_onselect(item) {
      this.budget_years.show = false;
      this.paymentForm.budget_year = item.name;
      // this.cost_center.cost_center = item.name;
      // this.cost_center.center_id = item.id;
    },
    getCostCenter() {
      this.$http.post("getcostcenter").then((res) => {
        console.log(res);
        if (res.data.code != 200) {
          console.log(res.data.msg);
        }
        this.cost_centers = res.data.data;
      });
    },
    getCostAccount() {
      this.$http.post("getcostaccount").then((res) => {
        console.log(res);
        if (res.data.code != 200) {
          console.log(res.data.msg);
          return false;
        }
        this.cost_accounts = res.data.data;
      });
    },
    //获取审批人
    getApprover() {
      this.$http.post("budget_apply/approver_org", this.paymentForm).then((res) => {
        this.paymentForm.approvers = res.data.data.approvers;
        this.paymentForm.copytos = res.data.data.copytos;
        console.log(this.paymentForm.approvers);
      });
    },

    department_onselect(item) {
      this.department.show = false;
      this.paymentForm.department = item.name;
      this.paymentForm.department_id = item.Id;
      // this.payment.department = item.name;
      this.approverForm.department_id = item.Id;
      // this.getApprover();
    },

    payment_submit() {
      this.paymentForm.filelist = this.files;
      // console.log(this.paymentForm);
      // return false;
      if (this.is_repeat == 1) {
        this.$dialog.alert({
          message: "重复提交，请稍等。",
        });
        return false;
      }
      this.is_repeat = 1;
      this.is_loading = true;
      this.$http.put("budget_apply", this.paymentForm).then((res) => {
        if (res.data.code != 200) {
          this.$dialog.alert({
            message: res.data.msg,
          });
          this.is_loading = false;
          this.is_repeat = 0;
          return false;
        }
        this.$dialog
          .alert({
            message: res.data.msg,
          })
          .then(() => {
            this.$router.push({ name: "MyFlow" });
          });
      });
    },

    uploadFiles(files) {
      // console.log(files);
      // return false;
      var formData = new FormData(); //构造一个 FormData，把后台需要发送的参数添加
      // 　　  formData.append('file', file); //接口需要传的参数
      // console.log(Array.isArray(files));
      if (Array.isArray(files)) {
        files.forEach(function (file) {
          formData.append("file[]", file.file); //接口需要传的参数
        });
      } else {
        formData.append("file[]", files.file);
      }

      // console.log(formData)
      this.$http.post("/upload/files", formData).then((res) => {
        if (res.data.code != 200) {
          this.$dialog.alert({
            message: res.data.msg,
          });
          return false;
        }
        // var file = {url:res.data.data.url}
        // this.fileList.push(file)
        // console.log(this.fileList)
        if (this.files == "") {
          this.files = [];
        }
        let that = this;
        res.data.data.forEach(function (item) {
          console.log(item);
          that.files.push(item);
        });
        // console.log(this.child_fileList)
        // console.log(this.files)
      });
    },
    deleteFile(item) {
      // console.log('11111')
      this.files.splice(item, 1);
    },

    type(file) {
      return fileType(file);
    },
    getImg(index) {
      ImagePreview({
        images: this.files, // 预览图片的那个数组
        showIndex: true,
        loop: false, //循环播放
        startPosition: index, // 指明预览第几张图
        showIndicators: true, //是否显示轮播指示器
        closeable: true, //是否显示关闭图标
      });
    },
  },
  computed: {
    amount: {
      get() {
        var cost_amount = 0;
        this.paymentForm.costs.forEach(function (e) {
          cost_amount += Number(e.amount);
        });
        this.paymentForm.amount = cost_amount;
        return cost_amount;
      },
      set() {},
    },
  },
  watch: {
    amount: function (value) {
      this.paymentForm.amount_word = digit_uppercase(value);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.van-cell-group__title {
  background-color: #3f51b5;
  font-size: 14px;
  font-weight: blod;
  color: white;
  padding: 13px;
}
.title-style {
  font-size: 26px;
}

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.img_box {
  display: inline-block;
}
.delete{
  top:0px;
  right:0px; 
  color:red;
  display: block;
  position:absolute; 
  font-size:28px;
}
.upload_img{
  display:inline;
  margin:15px;
}
</style>
